// TestimonialSlider.js
import React, { useState, useEffect } from "react";
import { Carousel, Col } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import "./TestimonialSlider.css";
import { BiSolidQuoteAltLeft } from "react-icons/bi";
import { ImQuotesRight } from "react-icons/im";
import { IoStar } from "react-icons/io5";

export default function TestimonialSlider() {
  const [columns, setColumns] = useState(1);
  const [activeIndex, setActiveIndex] = useState(0);

  const chunkArray = (arr, size) => {
    return Array.from({ length: Math.ceil(arr.length / size) }, (v, i) =>
      arr.slice(i * size, i * size + size)
    );
  };

  useEffect(() => {
    const updateColumns = () => {
      const screenWidth = window.innerWidth;
      if (screenWidth >= 999) {
        setColumns(3);
      } else {
        setColumns(1);
      }
    };
    updateColumns();
    window.addEventListener("resize", updateColumns);
    return () => {
      window.removeEventListener("resize", updateColumns);
    };
  }, []);

  const testimonials = [
    {
      id: 1,
      name: "Dr. Rajesh Kumar",
      review:
        "Currency Growth Financial Services has been a game-changer for my finances. Their expert advisors helped me create a personalized investment plan that exceeded my expectations. Highly recommend!",
      avatar: "/assets/images/test1.png",
    },
    {
      id: 2,
      name: " Anil Sharma",
      review:
        "I’ve been with Currency Growth Financial Services for over two years. Their competitive rates and seamless processes make managing my savings and investments effortless.",
      avatar: '/assets/images/test6.jpeg',
    },
    {
      id: 3,
      name: " Ravi Shankar",
      review:
        "Thanks to Currency Growth Financial Services, I finally have a clear path toward financial freedom. Their team is knowledgeable, and their resources are incredibly helpful.",
      avatar: '/assets/images/test5.jpeg',
    },
    {
      id: 4,
      name: " Vikram Singh ",
      review:
        "The team at Currency Growth Financial Services is always available to answer my questions. Their support and guidance make me feel secure about my financial decisions.",
      avatar: '/assets/images/test7.jpeg',
    },
    {
      id: 5,
      name: "Babu  Chandra",
      review:
        "Currency Growth Financial Services offers everything I need in one place—savings, investments, and great advice. It’s the perfect solution for anyone serious about their finances.",
      avatar: '/assets/images/test8.jpeg',
    },
    {
      id: 6,
      name: "Sardar Singh",
      review:
        "From savings accounts to personalized financial advice, Currency Growth Financial Services truly offers a comprehensive range of services. It’s all in one place, making my life much easier.",
      avatar: '/assets/images/man3.jpg',
    },
  ];
  const chunkedServiceItems = chunkArray(testimonials, columns);
  const handleSelect = (selectedIndex) => {
    setActiveIndex(selectedIndex);
  };

  return (
    <>
      {columns === 1 ? (
        <Carousel indicators controls>
          {testimonials.map((item, index) => (
            <Carousel.Item key={index}>
              <div
                className="row d-flex justify-content-center align-items-center"
                style={{
                  width: "80%",
                  marginLeft: "auto",
                  marginRight: "auto",
                }}
              >
                <div
                  className={`col-md-${12 / columns} col-lg-${12 / columns}`}
                >
                  <Col className="q">
                    <div className="firsttestimonial-content">
                      <div className="firsttestimonial-content-main">
                        <div className="firsttestimonial-content-main-header">
                          <h3 style={{ color: "black" }}>CLINTES </h3>
                          <p className="firsttestimonial-content-main-text">
                            TESTIMONIAL
                          </p>
                        </div>
                        <div
                          key={item.id}
                          className="firstavatar-container"
                          style={{
                            backgroundImage: `url(${item.avatar})`,
                          }}
                        />
                        <div className="firsttestimonial-icon-main">
                          <BiSolidQuoteAltLeft className="firsttestimonial-review-leftque" />
                          <span className="firsttestimonial-review">
                            {item.review}
                          </span>
                          <IoStar className="firsttestimonial-review-star" />
                          <IoStar className="firsttestimonial-review-star" />
                          <IoStar className="firsttestimonial-review-star" />
                          <IoStar className="firsttestimonial-review-star" />
                          <IoStar className="firsttestimonial-review-star" />
                          <ImQuotesRight className="firsttestimonial-review-rightque" />
                        </div>
                      </div>
                      <div className="firsttestimonial-name-main">
                        <p className="firsttestimonial-name-inside">
                          {item.name}
                        </p>
                      </div>
                      <div className="firstwave-divider">
                        <svg
                          viewBox="0 0 400 250"
                          className="firstwave-divider-svg"
                        >
                          <path
                            d="M 0 80 C 100 -40 250 120 400 50 L 500 300 L 0 300"
                            fill="#244DB8"
                          ></path>
                        </svg>
                      </div>
                    </div>
                  </Col>
                </div>
              </div>
            </Carousel.Item>
          ))}
        </Carousel>
      ) : (
        <Carousel
          activeIndex={activeIndex}
          onSelect={handleSelect}
          indicators
          controls
        >
          {chunkedServiceItems.map((chunk, index) => (
            <Carousel.Item key={index}>
              <div
                className="row d-flex justify-content-center align-items-center"
                style={{
                  width: "80%",
                  marginLeft: "auto",
                  marginRight: "auto",
                }}
              >
                {chunk.map((item, innerIndex) => (
                  <div
                    key={innerIndex}
                    className={`col-md-${12 / columns} col-lg-${12 / columns}`}
                  >
                    <Col className="p">
                      <div className="firsttestimonial-content">
                        <div className="firsttestimonial-content-main">
                          <div className="firsttestimonial-content-main-header">
                            <h3 style={{ color: "black" }}>CLINTES </h3>
                            <p className="firsttestimonial-content-main-text">
                              TESTIMONIAL
                            </p>
                          </div>
                          <div
                            key={item.id}
                            className="firstavatar-container"
                            style={{
                              backgroundImage: `url(${item.avatar})`,
                            }}
                          />
                          <div className="firsttestimonial-icon-main">
                            <BiSolidQuoteAltLeft className="firsttestimonial-review-leftque" />
                            <span className="firsttestimonial-review">
                              {item.review}
                            </span>
                            <IoStar className="firsttestimonial-review-star" style={{color:"gold"}}/>
                            <IoStar className="firsttestimonial-review-star" style={{color:"gold"}}/>
                            <IoStar className="firsttestimonial-review-star" style={{color:"gold"}}/>
                            <IoStar className="firsttestimonial-review-star" style={{color:"gold"}}/>
                            <IoStar className="firsttestimonial-review-star" style={{color:"gold"}}/>
                            <ImQuotesRight className="firsttestimonial-review-rightque" />
                          </div>
                        </div>
                        <div className="firsttestimonial-name-main">
                          <p className="firsttestimonial-name-inside">
                            {item.name}
                          </p>
                        </div>
                        <div className="firstwave-divider">
                          <svg
                            viewBox="0 0 400 250"
                            className="firstwave-divider-svg"
                          >
                            <path
                              d="M 0 80 C 100 -40 250 120 400 50 L 500 300 L 0 300"
                              fill="#244DB8"
                            ></path>
                          </svg>
                        </div>
                      </div>
                    </Col>
                  </div>
                ))}
              </div>
            </Carousel.Item>
          ))}
        </Carousel>
      )}
    </>
  );
}
